export default __webpack_public_path__ + "static/media/019-boxer.1f2f1e16.svg";